import { type Transition } from 'motion/react'
import React from 'react'

/**
 * Context which defines transition configurations shared amongst various components.
 *
 * Rather than using the context directly, you'll likely want to access functionality
 * via the helper hooks in `../hooks`, which handles additional options such as disabled
 * animations.
 */
export interface AnimationConfig {
  layoutTransition: Transition
  appearanceTransition: {
    startOpacity: number
    startScale: number
    duration: number
    ease: 'easeIn' | 'easeOut' | 'easeInOut'
  }
}

export type AnimationContextType = {
  animated: boolean
  config: AnimationConfig
}

export const DEFAULT_ANIMATION_CONFIG: AnimationConfig = {
  layoutTransition: {
    duration: 0.3,
    ease: 'easeOut',
  },
  appearanceTransition: {
    startOpacity: 0,
    startScale: 0.8,
    duration: 0.3,
    ease: 'easeInOut',
  },
}

export const AnimationContext = React.createContext<AnimationContextType>({
  animated: true,
  config: DEFAULT_ANIMATION_CONFIG,
})
